// Pure helpers for the sidebar tree. No React, no DOM -- `node --test`able.
// Paths, not enames, identify a node: the tree is a DAG (236 forms sit under
// more than one menu on production) and React keys by ename would drop one.

export function pathKey(parentPath, node) {
  return `${parentPath}/${node.id}`;
}

export function findFirstPath(root, ename) {
  const walk = (nodes, parent) => {
    for (const n of nodes) {
      const p = pathKey(parent, n);
      if (n.ename === ename) return p;
      const hit = walk(n.children || [], p);
      if (hit) return hit;
    }
    return null;
  };
  return walk(root, '');
}

function matches(node, q) {
  const hay = [node.ename, node.title_he, node.title_en].filter(Boolean).map(s => s.toLowerCase());
  return hay.some(s => s.includes(q));
}

export function ancestorPaths(path) {
  const parts = path.split('/').filter(Boolean);
  return parts.slice(0, -1).map((_, i) => '/' + parts.slice(0, i + 1).join('/'));
}

export function filterPaths(root, query) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return null;
  const shown = new Set();
  const walk = (nodes, parent, ancestors) => {
    for (const n of nodes) {
      const p = pathKey(parent, n);
      const here = [...ancestors, p];
      if (matches(n, q)) here.forEach(a => shown.add(a));
      walk(n.children || [], p, here);
    }
  };
  walk(root, '', []);
  return shown;
}
